import firebaseApp from '../../firebase/firebase';
import { FETCH_EVENTS, NO_EVENTS } from '../../_actions/types';


export const loadEventsFromFirebase = () => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;

    firebaseApp.database().ref(`events`).on('value', () => {
      firebaseApp.database().ref(`users/${id}/events`).on('value', snapshot => {
        const values = snapshot.val();
        if (values !== null) {
        const events = []
        for (let key of Object.keys(values)) {
          firebaseApp.database().ref(`events/${key}`).on('value', snapshot => {
            events.push(snapshot.val());
          });
        };
        dispatch({ type: FETCH_EVENTS, payload: events });
      } else {
        dispatch ({ type: NO_EVENTS });
      }
    })
    })
  };
};



// WEBPACK FOOTER //
// ./src/components/calendar/calendar_actions.js